import React, { useEffect, useState } from "react";
import clsx from "clsx";
import fp from "lodash/fp";
import OutsideClickHandler from "react-outside-click-handler";
import StatusToggleActiveView from "../../../components/status/StatusToggleActiveView";
import { DropDownArrowIcon } from "../../../components/icons";
import { GROUPING_VIEW_TYPE, LIST_VIEW_TYPE, TABLE_LIST_TYPE, UNCATEGORIZED_ID } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { assetsActions } from "../../../modules";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";
import queryParamsStringify from "../../../components/params/queryParamsStringify";
import useSearchQueryParams from "../../../components/params/useSearchQueryParams";
import SearchQueryParamsContext from "../../../components/params/SearchQueryParamsContext";
import { loadViewInfo, saveViewInfo } from "../../../cores/viewStorage";
import PopperMenu from "../../../components/tooltip/PopperMenu";
import compareVersions, { VERSION_CM_8339_FOLDER_VIEW } from "@cores/version";
import { getDrivesListAPI } from "@modules/apis/virtureFolder";
import { IconButton, Tooltip } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { IconAllView, IconHierarchy } from "@mzc-cloudplex/icons";
import useSettings from "@hooks/useSettings";
import { initFolderData } from "@modules/folderTreeView";
import { initCategoryData } from "@modules/categoryTreeView";

const AssetListViewSelectBtn = ({ domain, schemaId, activeView, onChangeActiveView }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { isCardView } = useSettings({ type: "General", domain: "assets" });

    // const boundedAssetsActions = bindActionCreators(assetsActions, dispatch);
    const [showDropdownLayer, setShowDropdownLayer] = useState(false);
    const searchQueryParamsContext = useSearchQueryParams(SearchQueryParamsContext);
    const { stage, project, assets, driveList } = useSelector(({ stage, project, assets, folderTreeView }) => ({
        stage,
        project,
        assets,
        driveList: folderTreeView.driveList,
    }));

    const onClickHierarchyViewType = async (type) => {
        const hierarchyType =
            compareVersions(stage.version, VERSION_CM_8339_FOLDER_VIEW) >= 0 && ["Asset", "Collection"].includes(domain)
                ? "folder"
                : "category";

        let params = {
            activeView: type,
        };
        if (type.toLowerCase() === LIST_VIEW_TYPE.HIERARCHY) {
            if (hierarchyType === GROUPING_VIEW_TYPE.CATEGORY) {
                if (domain === TABLE_LIST_TYPE.CUSTOM_CONTENT) {
                    await dispatch(initCategoryData(project.id, schemaId));
                } else {
                    await dispatch(initCategoryData(project.id, domain));
                }
            } else {
                dispatch(initFolderData({ headerParams: { projectId: project.id }, domain }));
            }
        } else {
            saveViewInfo(`${domain}ViewInfo`, {
                stageId: stage.id,
                projectId: project.id,
                activeView: "list",
                isCardView: isCardView,
            });
        }

        onChangeActiveView({ activeView: type, hierarchyType });

        searchQueryParamsContext.resetSearchQueryParams({
            action: "push",
            params,
        });

        setShowDropdownLayer(false);
    };

    return (
        <React.Fragment>
            <Tooltip
                title={
                    activeView === LIST_VIEW_TYPE.LIST
                        ? `${t(`common::label::Grouping View mode`, "Grouping View mode")}`
                        : `${t(`common::label::View All mode`, "View All mode")}`
                }
            >
                <IconButton
                    size={"medium"}
                    variant={"contained"}
                    sx={{
                        backgroundColor: theme.palette.primary.light,
                        "&:hover, &:focus, &:active, .Mui-Selected": {
                            backgroundColor: theme.palette.primary.light,
                        },
                        marginRight: 1,
                    }}
                    onClick={(e) => {
                        activeView === LIST_VIEW_TYPE.LIST
                            ? onClickHierarchyViewType(LIST_VIEW_TYPE.HIERARCHY)
                            : onClickHierarchyViewType(LIST_VIEW_TYPE.LIST);
                    }}
                >
                    {activeView === LIST_VIEW_TYPE.LIST ? <IconHierarchy size={16} /> : <IconAllView size={16} />}
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
};

export default AssetListViewSelectBtn;
